/*
 * TextMessagesPage
 *
 * This contains all the text for the TextMessagesPage container.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.containers.TextMessagesPage';

export default defineMessages({
  pageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'SMS Messaging',
  },
});
